"use client";

import { useState } from 'react';
import Link from 'next/link';

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <header className="border-b border-gray-300 py-4 bg-white sticky top-0 z-50">
            <div className="container mx-auto px-4 flex justify-between items-center max-w-4xl">
                <Link href="/" className="text-2xl font-bold tracking-tight text-blue-700" onClick={() => setIsMenuOpen(false)}>
                    In999
                </Link>

                {/* Desktop Navigation */}
                <nav className="hidden md:flex gap-x-6 text-sm font-medium items-center">
                    <Link href="/in999-login" className="hover:text-blue-700 transition-colors">Login</Link>
                    <Link href="/in999-download" className="hover:text-blue-700 transition-colors">Download</Link>
                    <Link href="/in999-bonus" className="hover:text-blue-700 transition-colors">Bonus</Link>
                    <Link href="/in999-review" className="hover:text-blue-700 transition-colors">Review</Link>
                    <Link href="/help" className="hover:text-blue-700 transition-colors text-orange-600 font-semibold italic flex items-center gap-1 group">
                        <span className="group-hover:animate-pulse">🆘</span> Help
                    </Link>
                    <Link href="/blog" className="hover:text-blue-700 transition-colors">Blog</Link>
                    <Link href="/in999-invite-code-withdrawal-support" className="bg-blue-700 text-white px-4 py-2 rounded shadow hover:bg-blue-800 transition">Register Now</Link>
                </nav>

                {/* Mobile Menu Button */}
                <button
                    className="md:hidden p-2 text-gray-600 hover:bg-gray-200 rounded focus:outline-none"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    aria-label="Toggle menu"
                >
                    {isMenuOpen ? (
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                    ) : (
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
                    )}
                </button>
            </div>

            {/* Mobile Navigation Menu */}
            {isMenuOpen && (
                <div className="md:hidden border-t py-4 px-4 bg-white absolute w-full shadow-lg">
                    <nav className="flex flex-col gap-y-4 text-base font-medium container mx-auto max-w-4xl">
                        <Link href="/in999-login" className="hover:text-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)}>Login</Link>
                        <Link href="/in999-download" className="hover:text-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)}>Download</Link>
                        <Link href="/color-prediction-games-india" className="hover:text-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)}>Games & Prediction</Link>
                        <Link href="/win-go-k3-5d-lottery-guide" className="hover:text-blue-700 transition-colors text-sm pl-2" onClick={() => setIsMenuOpen(false)}>└─ Win Go & K3 Guide</Link>
                        <Link href="/trx-hash-game-guide" className="hover:text-blue-700 transition-colors text-sm pl-2" onClick={() => setIsMenuOpen(false)}>└─ TRX Hash Guide</Link>
                        <Link href="/in999-bonus" className="hover:text-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)}>🎁 In999 Bonus & Rewards</Link>
                        <Link href="/in999-review" className="hover:text-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)}>✅ In999 Review</Link>
                        <Link href="/in999-customer-support" className="hover:text-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)}>📞 Customer Support</Link>
                        <Link href="/blog" className="hover:text-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)}>Blog</Link>
                        <Link href="/help" className="hover:text-orange-600 transition-colors text-orange-600 font-bold italic flex items-center gap-2" onClick={() => setIsMenuOpen(false)}>
                            <span>🆘</span> Help Center & FAQ
                        </Link>
                        <Link href="/what-is-in999" className="hover:text-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)}>What is In999?</Link>
                        <Link href="/about" className="hover:text-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)}>About Us</Link>
                        <Link href="/contact-us" className="hover:text-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)}>Contact Us</Link>
                        <div className="border-t pt-4 mt-2 flex flex-wrap gap-x-4 gap-y-2 text-xs text-gray-500">
                            <Link href="/privacy-policy" onClick={() => setIsMenuOpen(false)}>Privacy Policy</Link>
                            <Link href="/terms-and-conditions" onClick={() => setIsMenuOpen(false)}>Terms &amp; Conditions</Link>
                            <Link href="/disclaimer" onClick={() => setIsMenuOpen(false)}>Disclaimer</Link>
                        </div>
                        <Link href="/in999-invite-code-withdrawal-support" className="text-blue-700 font-bold border-t pt-4 mt-2" onClick={() => setIsMenuOpen(false)}>Register Now</Link>
                    </nav>
                </div>
            )}
        </header>
    );
}
